<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">Deposit</div>
                <div class="nav-tab">
                    <span class="tab" :class="{ activeTab: typePage == 'deposit' }" @click="filterTypeDeposit('deposit')">List Deposit</span>
                    <span class="tab" :class="{ activeTab: typePage == 'metal' }" @click="filterTypeDeposit('metal')">List Metal on Vault</span>
                </div>
                <list-deposit
                    v-if="typePage == 'deposit'"
                    :depositData="getDataDeposit"
                    :totalDeposit="getTotalData"
                    :pageNumber="currentPage"
                    :totalPerPage="perPage"
                    :isLoadingData="isLoading"
                    :typeDeposit="typeDeposit"
                    @setFilterTable="filterTable"
                ></list-deposit>
                <list-metal
                    v-else
                    :metalData="getDataDeposit"
                    :pageNumber="currentPage"
                    :totalPerPage="perPage"
                    :dataClient="getDataClient"
                    :dataContract="getDataContract"
                    :isLoadingData="isLoading"
                    :totalData="getTotalData"
                    :typeDeposit="typeDeposit"
                    @setFilterTable="filterTable"
                ></list-metal>

                <div class="d-flex justify-content-end mt-3" v-if="!isLoading">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="getTotalData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="getTotalData > 10"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListMetal from "../components/deposit/ListMetal.vue";
import ListDeposit from "../components/deposit/ListDeposit.vue";
export default {
    components: { ListMetal, ListDeposit },
    data() {
        return {
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            typePage: "deposit",
            typeDeposit: "onexchange",
            contract_id: "",
            owner: "",
            hallmark: "",
            activity: "deposit",
            startDate: "",
            endDate: "",
            serialNumber: "",
            status: "",
            dateType: "",
        };
    },
    mounted() {
        this.getData(
            this.activity,
            this.owner,
            this.startDate,
            this.endDate,
            this.serialNumber,
            this.hallmark,
            this.status,
            this.dateType,
            this.perPage,
            this.currentPage,
            this.contract_id,
            this.typeDeposit
        );
    },
    methods: {
        filterTable(event) {
            this.owner = event.owner;
            this.startDate = event.startDate;
            this.endDate = event.endDate;
            this.serialNumber = event.serial_number;
            this.hallmark = event.hallmark;
            this.status = event.status;
            this.dateType = event.dateType;
            this.contract_id = event.contract_id;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.typeDeposit
            );
        },
        handlePageChange(value) {
            this.currentPage = value;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.typeDeposit
            );
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        filterTypeDeposit(value) {
            this.currentPage = 1;
            this.typePage = value;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.typeDeposit
            );
        },
        getData(activity, owner, startDate, endDate, serialNumber, hallmark, status, dateType, perPage, currentPage, contract_id, type) {
            if (this.typePage == "deposit") {
               this.$store.dispatch("getListMetal", {
                    activity: '',
                    perPage: perPage,
                    currentPage: currentPage,
                    startDate: startDate,
                    endDate: endDate,
                    type: type,
                    owner: owner,
                    serialNumber: serialNumber,
                    hallmark: hallmark,
                    dateType: dateType,
                    status: status,
                    contract_id: contract_id,
                });
            } else {
                this.$store.dispatch("getListMetal", {
                    activity: activity,
                    perPage: perPage,
                    currentPage: currentPage,
                    startDate: startDate,
                    endDate: endDate,
                    type: type,
                    owner: owner,
                    serialNumber: serialNumber,
                    hallmark: hallmark,
                    dateType: dateType,
                    status: status,
                    contract_id: contract_id,
                });
            }
        },
    },
    computed: {
        rows() {
            return (this.currentPage - 1) * this.perPage;
        },
        getDataDeposit() {
            return this.$store.state.vaultModul.depositData;
        },
        getTotalData() {
            return this.$store.state.vaultModul.totalData;
        },
        isLoading() {
            return this.$store.state.vaultModul.isLoading;
        },
        getDataContract() {
            return this.$store.state.vaultModul.dataContract;
        },
        getDataClient() {
            return this.$store.state.vaultModul.dataClient;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.nav-tab {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #636366;
    padding: 0.8rem 0;
    justify-self: flex-start;
}

.tab {
    padding: 0.8rem 1rem;
    cursor: pointer;
}

.tab:hover,
.activeTab {
    color: var(--clr-scondary);
    border-bottom: 2px solid var(--clr-scondary);
}

label {
    width: 50%;
    text-align: left;
}

.select-input,
input {
    width: 100%;
}

.form-group {
    display: flex;
}

.select-input,
input {
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 0 10px;
    font-size: 13px;
}

.button-add {
    text-align: right;
    font-size: 13px;
}

.content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.icon-trade {
    width: 25px;
}

.footer {
    background: var(--clr-primary);
    color: white;
    padding: 20px 47px;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 62px;
}

.filter {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-size: 12px;
    flex-wrap: wrap;
}

.wrap-input {
    margin-bottom: 10px;
}
.label-input {
    width: 110px;
}
select {
    width: 130px;
    border-radius: 3px;
    border-color: #a5a5a5a5;
    padding: 3px;
}

.card {
    width: 314px;
    font-size: 14px;
    border-radius: 10px;
}

.card-header {
    padding: 1rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    position: relative;
    left: 20px;
}

.title::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--clr-scondary);
    left: -17px;
    top: 3px;
}

.buyer {
    margin-bottom: 20px;
}

.content-right {
    text-align: right;
}

.amount {
    font-weight: bold;
}

.btn-primer {
    background: var(--clr-scondary);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-primer:hover {
    background-color: var(--clr-scondary-hover);
}

.clearing {
    /* background: rgba(50, 90, 115, 0.1); */
    font-weight: 600;
    color: rgb(50, 90, 115);
    border-radius: 5px;
}
.operator,
.error {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(252, 108, 4);
    border-radius: 5px;
}
.stored {
    /* background: rgba(40, 167, 69, 0.1); */
    font-weight: 600;
    color: rgb(40, 167, 69);
    border-radius: 5px;
}
.abx {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(172, 143, 26);
    border-radius: 5px;
}

.vendor {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(250, 194, 75);
    border-radius: 5px;
}

.reject {
    font-weight: 600;
    color: rgb(250, 119, 75);
    border-radius: 5px;
}
</style>
